import React, {useContext} from 'react';
import {CalendarSpecVal} from 'moment';
import {CalendarSpec} from 'moment/moment';
import {DateTime} from '@src/@types/DateTime';
import {moment, MomentJs} from '@src/helpers/dates';
import {LocaleContext} from '@src/contexts/LocaleContext';

export default function MomentDate(props: {
    date: MomentJs | Date | DateTime,
    defaultValue?: number | Date,
    format?: string,
    calendar?: CalendarSpec,
    calendarSameDay?: CalendarSpecVal;
    calendarNextDay?: CalendarSpecVal;
    calendarLastDay?: CalendarSpecVal;
    calendarNextWeek?: CalendarSpecVal;
    calendarLastWeek?: CalendarSpecVal;
    calendarSameElse?: CalendarSpecVal;
    fromNow?: boolean | null, // value - withoutSuffix state
    fromNowWithoutSuffix?: true,
    fromNowWithSuffix?: true,
    withWrapperTag?: React.ComponentType<{ title: string }> | keyof React.JSX.IntrinsicElements,
}) {
    useContext(LocaleContext);

    let value: string;
    const instance = moment(props.date);

    if (props.format) {
        value = instance.format(props.format);

    } else if (props.calendar) {
        value = instance.calendar(props.calendar);

    } else if (props.calendarSameDay) {
        value = instance.calendar({sameDay: props.calendarSameDay});

    } else if (props.calendarNextDay) {
        value = instance.calendar({nextDay: props.calendarNextDay});

    } else if (props.calendarLastDay) {
        value = instance.calendar({lastDay: props.calendarLastDay});

    } else if (props.calendarNextWeek) {
        value = instance.calendar({nextWeek: props.calendarNextWeek});

    } else if (props.calendarLastWeek) {
        value = instance.calendar({lastWeek: props.calendarLastWeek});

    } else if (props.calendarSameElse) {
        value = instance.calendar({sameElse: props.calendarSameElse});

    } else if (props.fromNowWithSuffix === true) {
        value = instance.fromNow(false);

    } else if (props.fromNowWithoutSuffix === true) {
        value = instance.fromNow(true);

    } else if (props.fromNow !== undefined) {
        value = instance.fromNow(props.fromNow ?? undefined);

    }

    value ??= instance.toString();

    if (props.withWrapperTag) {
        const Tag = props.withWrapperTag;

        return <Tag title={instance.toDate().toLocaleString()}>{value}</Tag>;
    }

    return <React.Fragment>{value}</React.Fragment>;
}
